import React from "react";

const AddOutlinedIcon: React.FC = () => (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.09766 11.1362H17.2196"
        stroke="#B5B5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6582 16.6971V5.5752"
        stroke="#B5B5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

export default AddOutlinedIcon;
